"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _TagList = _interopRequireDefault(require("../tag/TagList"));
var _Tag = _interopRequireDefault(require("../tag/Tag"));
var TagManagerItemList = function TagManagerItemList(props) {
  var tags = props.tags,
    onRemoveFromTagList = props.onRemoveFromTagList;
  return /*#__PURE__*/_react["default"].createElement(_TagList["default"], {
    inline: false
  }, tags.map(function (tag) {
    var tagClasses = (0, _classnames["default"])(tag.toAdd && 'border-color-success text-color-success', tag.toRemove && 'border-color-danger text-color-danger');
    return /*#__PURE__*/_react["default"].createElement(_Tag["default"], {
      key: tag.label,
      className: tagClasses,
      deletable: true,
      round: false,
      onClick: function onClick() {
        return onRemoveFromTagList(tag);
      }
    }, tag.label);
  }));
};
TagManagerItemList.defaultProps = {};
TagManagerItemList.propTypes = {
  tags: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string,
    toAdd: _propTypes["default"].bool,
    toRemove: _propTypes["default"].bool
  })),
  onRemoveFromTagList: _propTypes["default"].func
};
var _default = TagManagerItemList;
exports["default"] = _default;